import {cloneDeep, get} from "lodash";
import {getString} from "Core/helpers/data";
import {PatientRecordExpertReportsListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {PatientRecordExpertReportsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new PatientRecordExpertReportsListItemDataObject(
		getString(result, 'uniqueId'),
		getDate(get(result, 'reportDate'), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getString(result, 'title'),
	);

	return result;
}

// @note There is no output function since list is read only.